import axios from 'axios'
//import { Store } from '../store'
const SCHEME = 'https'
const HOSTNAME = 'trioteca.com'
const API_URL = `${SCHEME}://${HOSTNAME}/api`

const HTTP = axios.create({
  baseURL: API_URL
})

HTTP.interceptors.response.use(function (response) {
  // console.log('interceptor response: ', response)
  return response
}, function (error) {
  //console.log('interceptor error: ', error)
  if (error.response.status === 401) {
    //Store.commit('user/SHOW_SOCIAL_LOGIN_POPUP', true)
  }
  return Promise.reject(error)
})

export { HTTP }
